import { lazy } from 'react';

export const ProfileManagementPageLazy = lazy(
    () => import('./profile-management-page'),
);
